import { Link } from 'react-router-dom';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center py-12 px-6">
      <div className="max-w-4xl w-full bg-white rounded-3xl shadow-xl overflow-hidden">
        {/* Header Section */}
        <div className="relative bg-emerald-900 py-20 px-8 text-center text-white">
          <div className="absolute inset-0 opacity-20 bg-[url('/hero-bali.jpg')] bg-cover bg-center"></div>
          <div className="relative z-10">
            <h1 className="text-4xl md:text-5xl font-extrabold mb-4 tracking-tight leading-tight">
              About Bali Rental Finder
            </h1>
            <p className="text-xl text-emerald-100 font-light max-w-2xl mx-auto">
              Simplifying the search for long-term homes and digital nomad retreats in Paradise.
            </p>
          </div>
          <Link to="/" className="absolute top-6 left-6 text-emerald-100 hover:text-white flex items-center gap-2 transition-colors">
             <span className="text-xl">←</span> Back to Listings
          </Link>
        </div>

        {/* Content Section */}
        <div className="p-8 md:p-12 space-y-12">
          {/* Mission */}
          <section>
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
              <span className="text-3xl">🌴</span> Our Mission
            </h2>
            <div className="prose prose-emerald text-gray-700 max-w-none leading-relaxed">
              <p>
                Finding a long-term rental in Bali can be overwhelming. Between scattered Telegram groups, 
                social media posts, and local agents, the best deals are often hidden in the noise. 
              </p>
              <p>
                <strong>Bali Rental Finder</strong> was built to aggregate, curate, and structure these listings 
                using advanced AI. We transform chaotic group messages into a searchable, clean interface 
                so you can spend less time scrolling and more time enjoying island life.
              </p>
            </div>
          </section>

          {/* How it Works */}
          <section className="bg-amber-50 rounded-2xl p-8 border border-amber-100">
            <h2 className="text-3xl font-bold text-amber-900 mb-6 flex items-center gap-3">
              <span className="text-3xl">🤖</span> How It Works
            </h2>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="space-y-3">
                <div className="w-12 h-12 bg-amber-200 text-amber-900 rounded-full flex items-center justify-center font-bold text-xl">1</div>
                <h3 className="font-bold text-amber-900">Aggregate</h3>
                <p className="text-amber-800 text-sm">We monitor dozens of trusted Telegram groups and community channels for the latest property listings.</p>
              </div>
              <div className="space-y-3">
                <div className="w-12 h-12 bg-amber-200 text-amber-900 rounded-full flex items-center justify-center font-bold text-xl">2</div>
                <h3 className="font-bold text-amber-900">Extract</h3>
                <p className="text-amber-800 text-sm">Our AI analyzes every post to extract key details: price, location, bedrooms, and amenities.</p>
              </div>
              <div className="space-y-3">
                <div className="w-12 h-12 bg-amber-200 text-amber-900 rounded-full flex items-center justify-center font-bold text-xl">3</div>
                <h3 className="font-bold text-amber-900">Connect</h3>
                <p className="text-amber-800 text-sm">We provide direct links to the original source and contact info so you can reach out to owners immediately.</p>
              </div>
            </div>
          </section>

          {/* Contact Section */}
          <section className="text-center py-8">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Get in Touch</h2>
            <p className="text-gray-600 mb-8 max-w-xl mx-auto">
              Have questions, feedback, or found a bug? We'd love to hear from you. 
              Send us a message and we'll get back to you as soon as possible.
            </p>
            <div className="flex justify-center">
              <a 
                href="mailto:hello@balirentalfinder.com" 
                target="_blank"
                rel="noopener noreferrer"
                className="px-10 py-4 bg-emerald-900 text-white font-bold rounded-full hover:bg-black transition-all shadow-lg hover:shadow-xl active:scale-95 flex items-center gap-2"
              >
                <span>✉️</span> Email Support
              </a>
            </div>
          </section>
        </div>

        {/* Footer */}
        <div className="bg-gray-50 p-6 text-center text-sm text-gray-400 border-t">
          &copy; {new Date().getFullYear()} Bali Rental Finder. Not an agency, just a helper.
        </div>
      </div>
    </div>
  );
}
